import { css, styled } from 'styled-components';

import { colors, cssBreakpoints, fontWeights } from '#/theme/theme';
import type { Color } from '#/theme/theme';

export const listingViewHeaderDesktopShadowSize = 24;

export const ListingViewHeaderHolder = styled.header`
  position: relative;
`;

export const ListingViewHeaderTagHolder = styled.div<{
  $color: Color;
}>`
  margin-top: 24px;
  display: inline-flex;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    border-radius: 8px;
    padding: 8px ${listingViewHeaderDesktopShadowSize}px;
    transform: translateX(-${listingViewHeaderDesktopShadowSize}px);

    ${(props) => css`
      background: ${colors[props.$color]};
    `};
  }
`;

export const ListingViewHeaderContentHolder = styled.div`
  /* Compensate for box-shadow in ListingViewHeaderContent */
  padding: ${listingViewHeaderDesktopShadowSize}px 0;
  margin-top: 24px;
`;

export const ListingViewHeaderContent = styled.div`
  background: ${colors.backgroundGrey};
  box-shadow: 0 0 0 ${listingViewHeaderDesktopShadowSize}px
    ${colors.backgroundGrey};

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    border-radius: 4px;
  }
`;

export const ListingViewHeaderTitle = styled.h1`
  font-size: 36px;
  color: ${colors.mediumContentGrey};
  margin: 0;
  font-weight: ${fontWeights.semiBold};
  word-break: normal;
  overflow-wrap: anywhere;
`;

export const ListingViewHeaderOrgName = styled.div`
  font-size: 20px;
  margin-top: 8px;
`;

export const ListingViewHeaderLocationDescription = styled.div`
  border-top: 1px solid ${colors.dustyBlue};
  padding-top: 16px;
  margin-top: 16px;
  display: flex;
  gap: 4px;
`;
